module.exports = __webpack_public_path__ + "assets/edit-res-base.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/edit-res-base.png
// module id = 1186
// module chunks = 7